export const TIER_LIMIT = [1000, 10000, 100000];
